import { Layout } from 'antd';

import Breadcrumbs from './Breadcrumbs';
import UserDropdown from './UserDropdown';

const { Header } = Layout;

interface AppHeaderProps {
  email: string;
  name: string;
  role: string;
  onLogout: () => void;
}

/**
 * Dumb component — top header bar with breadcrumbs and user dropdown.
 * All data comes from props.
 */
export default function AppHeader({ email, name, role, onLogout }: AppHeaderProps) {
  return (
    <Header
      style={{
        background: '#fff',
        padding: '0 24px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        boxShadow: '0 1px 4px rgba(0,0,0,0.08)',
        position: 'sticky',
        top: 0,
        zIndex: 100,
        height: 64,
      }}
    >
      <Breadcrumbs />

      <UserDropdown email={email} name={name} role={role} onLogout={onLogout} />
    </Header>
  );
}
